module.exports = __webpack_public_path__ + "static/media/everything-i-never-told-you.2a1420f2.jpg";